import * as React from 'react';
import './styles.scss';

interface PdfViewProps {
    url: string;
    isToolbar?: boolean;
}

const PdfView: React.FC<PdfViewProps> = ({ url, isToolbar = false }) => {
    const toolbar = !isToolbar ? '#toolbar=0&navpanes=0' : '';
    return (
        <>
            <iframe src={url + toolbar} />
        </>
    );
};

export default PdfView;





